import img1 from '../assets/leaderboard/man.png';
import img2 from '../assets/leaderboard/man2.png';
import img3 from '../assets/leaderboard/man3.png';


var LeaderData = [
    {
        img : img3, 
        rank : "#1",
        name : "Rahul",
        desc : "Hey! | Earned So Many Rewards You Can Yoo!",
    },
    {
        img : img2, 
        rank : "#2",
        name : "Vamsi",
        desc : "You Can Earn So Many Rewards Directly To Your Paytm Wallet",
    },
    {
        img : img1, 
        rank : "#3",
        name : "Aman",
        desc : "Best Apps To Play Games And Earn Rewards",
    },
];

export default LeaderData;